console.log('js/forms.js -> v0.1.0');
$(function() {
	$("input[type=range]").on('input', function() {
		var $this = $(this);
		var target = $this.data('target');
		if ($(target).length)
			$(target).text($this.val() + ($this.data('percent') ? '%' : ''));
	});
});

